import { render, staticRenderFns } from "./RichText.vue?vue&type=template&id=a873baf4&"
import script from "./RichText.vue?vue&type=script&lang=js&"
export * from "./RichText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports